var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.95C11.8667 14.95 11.7417 14.9292 11.625 14.8875C11.5084 14.8459 11.4 14.775 11.3 14.675L6.70005 10.075C6.51672 9.89169 6.42505 9.65836 6.42505 9.37502C6.42505 9.09169 6.51672 8.85836 6.70005 8.67502C6.88338 8.49169 7.11672 8.40002 7.40005 8.40002C7.68338 8.40002 7.91672 8.49169 8.10005 8.67502L12 12.575L15.9 8.67502C16.0834 8.49169 16.3167 8.40002 16.6 8.40002C16.8834 8.40002 17.1167 8.49169 17.3 8.67502C17.4834 8.85836 17.575 9.09169 17.575 9.37502C17.575 9.65836 17.4834 9.89169 17.3 10.075L12.7 14.675C12.6 14.775 12.4917 14.8459 12.375 14.8875C12.2584 14.9292 12.1334 14.95 12 14.95Z",
    fill: "#1C2227"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandDown);
export default __webpack_public_path__ + "static/media/expand_down.0f4a8fbb3e5bc70ba4c6c6dc769fc478.svg";
export { ForwardRef as ReactComponent };